import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import { amber, green } from '@material-ui/core/colors';
import useObservable from 'inc/hooks/useObservable';
import store from 'inc/store';

const variantIcon: { [k: string]: React.ElementType } = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles((theme: Theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

type Props = {
  type: 'snackbar' | 'inline',
}

function Message() {
  const classes: any = useStyles();
  const message = useObservable('page.message');
  const handleClose = (event?: React.SyntheticEvent<any>, reason?: string) => {
    reason !== 'clickaway' && store('page.message').clear();
  };
  const Icon = variantIcon[message.type];
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={6000}
      onClose={handleClose}
      open={!!message.text}
    >
      <SnackbarContent
        action={[
          <IconButton
            aria-label="close"
            color="inherit"
            key="close"
            onClick={() => handleClose()}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        aria-describedby="client-snackbar"
        className={clsx(classes[message.type])}
        message={
          <span id="client-snackbar">
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message.text}
          </span>
        }
      />
    </Snackbar>
  );
}

export default Message;
